export const SESSION_LINKS = {
  VIEW_LINKS: 'viewLinks',
  EDIT_LINKS: 'editLinks',
};

export const WIDGET_RENDER_FROM = [
  'Report-Details',
  'Dashboard-Widget',
  'Widget-Container',
];

export const SOURCE = {
  HOME: 'home',
  DETAILS: 'details',
};

export const DASHBOARD_APPLIED_FILTERS_STORAGE_KEY =
  'dashboard-applied-filters';

export const CLEAR_ALL_FILTERS_CONFIRM = {
  HEADER: 'Clear All Filters',
  MESSAGE:
    'This will remove all filters from this dashboard and save the change. Do you want to continue?',
  ACCEPT_LABEL: 'Clear All',
  REJECT_LABEL: 'Cancel',
};
